import React from 'react';
import { Helmet } from 'react-helmet-async';

export const PageSEO = ({
  title,
  description,
  path,
  ogImage = '/letshost-share-preview.png',
  noindex = false,
  preloadLcpImage = null,
  faqSchema = null,
}) => {
  const canonical = `https://letshost.nyc${path.startsWith('/') ? '' : '/'}${path}`;
  
  // Always use an absolute URL for social images
  const absoluteImageUrl = ogImage.startsWith('http') 
    ? ogImage 
    : `https://letshost.nyc${ogImage.startsWith('/') ? '' : '/'}${ogImage}`;
  
  // Generate FAQ schema if provided
  const generateFaqSchema = () => {
    if (!faqSchema || faqSchema.length === 0) return null;
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqSchema.map(item => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer
        }
      }))
    };
  };

  // Create a structured object for meta tags to ensure priority
  const metaTags = [
    { property: "og:image", content: absoluteImageUrl },
    { property: "og:image:url", content: absoluteImageUrl },
    { property: "og:image:secure_url", content: absoluteImageUrl },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:type", content: "image/png" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonical },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:site_name", content: "LetsHost NYC" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:url", content: canonical },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: absoluteImageUrl },
    { name: "title", content: title },
    { name: "description", content: description }
  ];

  // Add noindex, nofollow meta tags if noindex is true
  if (noindex) {
    metaTags.push({ name: "robots", content: "noindex, nofollow" });
    metaTags.push({ name: "googlebot", content: "noindex, nofollow" });
  }

  return (
    <Helmet
      title={title}
      meta={metaTags}
      prioritizeSeoTags
      encodeSpecialCharacters={true}
    >
      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />
      
      {/* Preload LCP image if provided */}
      {preloadLcpImage && (
        <link 
          rel="preload" 
          as="image" 
          href={preloadLcpImage.startsWith('/') ? preloadLcpImage : `/${preloadLcpImage}`}
          type={preloadLcpImage.endsWith('.webp') ? "image/webp" : undefined}
        />
      )}
      
      {/* FAQ Schema for GEO */}
      {generateFaqSchema() && (
        <script type="application/ld+json">
          {JSON.stringify(generateFaqSchema())}
        </script>
      )}
    </Helmet>
  );
}; 